export class GetTaskListRequestFilterModel {
  Search!: string;
  SearchInDescription: boolean = false;
  StatusId!: Array<number>;
  GlobalStatusIds!: Array<string>;
  PriorityId!: Array<number>;
  WithoutPriorities?: boolean = false;
  PerformerIds!: Array<number>;
  ObserverIds!: Array<number>;
  AuthorIds!: Array<number>;
  DifficultyIds!: Array<string>;
  TagIds!: Array<number>;
  WithoutTags?: boolean = false;
  IsAuthorOrPerformer: boolean = false;
  EstimateFrom?: number;
  EstimateTo?: number;
  WorkTimeFrom?: number;
  WorkTimeTo?: number;
  DateExecutEnd?: Date;
  DateExecutStart?: Date;
  TypeIds!: Array<string>;
  SearchByStatusName: boolean = false;
  constructor(obj?: Partial<GetTaskListRequestFilterModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
